import staffApi from "@/api/api-staff";
import reportApi from "@/api/api-report";
const common = {
    // js正则实现数字格式化,每三位加逗号
    getNumberFormatter(value) {
        if (!value) return '0';
        /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
        var intPart = Number(value) | 0; //获取整数部分
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
        var floatPart = ""; // ".0" 预定义小数部分
        var value2Array = value.split(".");

        //=2表示数据有小数位
        if (value2Array.length == 2) {
            floatPart = value2Array[1].toString().substr(0, 2); //拿到小数部分
            if (floatPart == '0' || floatPart == 0) { //补0,实际上用不着
                return intPartFormat // parseFloat(intPartFormat + "." + floatPart) // + '0';
            } else {
                return (intPartFormat + "." + floatPart) //parseFloat(intPartFormat + "." + floatPart);
            }
        } else {
            return intPartFormat // + floatPart;
        }
    },
    /**
     * 时间格式转换
     * @param {*} data
     */
    getDay(date) {
        let myDate = new Date(date)
        var days = myDate.getDay();
        switch (days) {
            case 1:
                days = '一';
                break;
            case 2:
                days = '二';
                break;
            case 3:
                days = '三';
                break;
            case 4:
                days = '四';
                break;
            case 5:
                days = '五';
                break;
            case 6:
                days = '六';
                break;
            case 0:
                days = '日';
                break;
        }
        return days;
    },
    getDate(date) {
        let d = new Date(date)
        return d.getDate()
    },
    getMonthDate(date) {
        let d = new Date(date)
        return (d.getMonth() + 1) + '月' + d.getDate() + '日'
            // return (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '月' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate()) + '日'
    },
    getDateDetail() {
        var d = new Date();
        return d.getFullYear() + '' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate()) + (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) + (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) + (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())

    },
    getDateDetail2() {
      var d = new Date();
      return d.getFullYear() + '-' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) +'-'+ (d.getDate() > 9 ? d.getDate() : '0' + d.getDate()) +' '+(d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) +':'+ (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) +':'+(d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())

  },
    getMonth(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' // + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return str
    },
    getMonthDetail(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-01'
        return str
    },
    getDateTime(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate())
        return str
    },
    getTime(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() // + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return str
    },
    getTimeDetail(date) {
        let d = new Date(date);
        let str = (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) + ':' + (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) + ':' + (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds());
        return str;
    },
    // 保留1位小数
    formatDecimal(value) {
        if (!value) return '0';
        /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
        var intPart = Number(value) | 0; //获取整数部分
        var floatPart = ""; // ".0" 预定义小数部分
        var value2Array = value.split(".");
        if (value2Array.length == 2) {
            floatPart = value2Array[1].toString().substr(0, 2); //拿到小数部分
            if (floatPart == '0' || floatPart == 0) { //补0,实际上用不着
                return intPart // parseFloat(intPartFormat + "." + floatPart) // + '0';
            } else {
                return (intPart + "." + floatPart) //parseFloat(intPartFormat + "." + floatPart);
            }
        } else {
            return intPart
        }
    },
    // 保留1位小数
    toDecimal1(x) {
        var f = parseFloat(x)
        if (isNaN(f)) {
            return false
        }
        var f = Math.round(x * 10) / 10
        var s = f.toString()
        var rs = s.indexOf('.')
            // if (rs < 0) {
            //     return s
            // }
        if (rs < 0) {
            rs = s.length
            s += '.'
        }
        while (s.length <= rs + 1) {
            s += '0'
        }
        return s //parseFloat(s)
    },
    // 保留两位小数
    toDecimal3(x) {
      var f = parseFloat(x)
      if (isNaN(f)) {
          return false
      }
      var f = Math.round(x * 1000) / 1000
      var s = f.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
          return s
      }
      // if (rs < 0) {
      //   rs = s.length
      //   s += '.'
      // }
      // while (s.length <= rs + 2) {
      //     s += '0'
      // }
      return parseFloat(s)
  },
    // 保留两位小数
    toDecimal2(x) {
        var f = parseFloat(x)
        if (isNaN(f)) {
            return false
        }
        var f = Math.round(x * 100) / 100
        var s = f.toString()
        var rs = s.indexOf('.')
        if (rs < 0) {
            return s
        }
        // if (rs < 0) {
        //   rs = s.length
        //   s += '.'
        // }
        // while (s.length <= rs + 2) {
        //     s += '0'
        // }
        return parseFloat(s)
    },
    // 保留两位小数不足的补零
    toDecimalComplement(x) {
        var f = parseFloat(x)
        if (isNaN(f)) {
            return false
        }
        var f = Math.round(x * 100) / 100
        var s = f.toString()
        var rs = s.indexOf('.')
            // if (rs < 0) {
            //     return s
            // }
        if (rs < 0) {
            rs = s.length
            s += '.'
        }
        while (s.length <= rs + 2) {
            s += '0'
        }
        return s //parseFloat(s)
    },
    getNewDate(data) {
        let str = null
        if (typeof(data) !== 'undefined' && data != null) {
            str = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data)
        }
        return str
    },

    compareDateToNow(date) {
        let result = new Date(date.replace(/\-/g, '\/')) < new Date() - 86400000
        return result
    },
    // 获取前一天
    getPerDate(n = 1) {
        var time = (new Date).getTime() - n * 24 * 60 * 60 * 1000;
        var yesterday = new Date(time);
        var month = yesterday.getMonth();
        var day = yesterday.getDate();
        yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
        return yesterday
    },
    // 获取指定日期前n天
    getCPerDate(date, n = 1) {
        var time = new Date(date).getTime() - n * 24 * 60 * 60 * 1000;
        var yesterday = new Date(time);
        var month = yesterday.getMonth();
        var day = yesterday.getDate();
        yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() >= 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? yesterday.getDate() : ("0" + yesterday.getDate()));
        return yesterday
    },
    // 获取当前日期前12个月
    getCPerMonth() {
        var dataArr = [];
        var data = new Date();
        var year = data.getFullYear();
        // data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
        for (var i = 0; i < 12; i++) {
            data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
            var m = data.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            dataArr.push(data.getFullYear() + "-" + (m) + "-01")
        }
        console.log(dataArr);
        return dataArr
    },
    datedifference(sDate1, sDate2) { //sDate1和sDate2是2006-12-18格式
        var dateSpan,
            tempDate,
            iDays;
        sDate1 = Date.parse(sDate1);
        sDate2 = Date.parse(sDate2);
        dateSpan = sDate2 - sDate1;
        dateSpan = Math.abs(dateSpan);
        iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
        return iDays
    },
    formatDecimal1(value) {
        if (!value) return '0'
            /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正 */
        var intPart = Number(value) | 0 // 获取整数部分
        var floatPart = '' // ".0" 预定义小数部分
        var value2Array = value.split('.')
        if (value2Array.length == 2) {
            floatPart = value2Array[1].toString().substr(0, 1) // 拿到小数部分
            if (floatPart == '0' || floatPart == 0) { // 补0,实际上用不着
                return intPart + '.0' // parseFloat(intPartFormat + "." + floatPart) // + '0';
            } else {
                return intPart + '.' + floatPart // parseFloat(intPartFormat + "." + floatPart);
            }
        } else {
            return intPart + '.0'
        }
    },
    // 保留2位小数（不补零）
    formatDecimal2(value) {
        if (!value) return '0'
            /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正 */
        var intPart = Number(value) | 0 // 获取整数部分
        var floatPart = '' // ".0" 预定义小数部分
        var value2Array = value.split('.')
        if (value2Array.length == 2) {
            if (value2Array[1].toString().substr(0, 1) == '0' || value2Array[1].toString().substr(0, 1) == 0 || value2Array[1].toString().substr(0, 2) == '00' || value2Array[1].toString().substr(0, 2) == 0) {
                return intPart + '.00'
            } else if (value2Array[1].toString().length == 1) {
                return intPart + '.' + value2Array[1] + '0' // parseFloat(intPartFormat + "." + floatPart);
            } else {
                floatPart = value2Array[1].toString().substr(0, 2) // 拿到小数部分
                return intPart + '.' + floatPart
            }
        } else {
            return intPart + '.00'
        }
    },
    // 加
    floatAdd(arg1, arg2) {
        var r1, r2, m
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
    },

    // 减
    floatSub(arg1, arg2) {
        var r1, r2, m, n
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
            //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2
        return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },

    // 乘
    floatMul(arg1, arg2) {
        var m = 0,
            s1 = arg1.toString(),
            s2 = arg2.toString()
        try {
            m += s1.split('.')[1].length
        } catch (e) {}
        try {
            m += s2.split('.')[1].length
        } catch (e) {}
        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },

    // 除
    floatDiv(arg1, arg2) {
        var t1 = 0,
            t2 = 0,
            r1, r2
        try {
            t1 = arg1.toString().split('.')[1].length
        } catch (e) {}
        try {
            t2 = arg2.toString().split('.')[1].length
        } catch (e) {}

        r1 = Number(arg1.toString().replace('.', ''))

        r2 = Number(arg2.toString().replace('.', ''))
        return (r1 / r2) * Math.pow(10, t2 - t1)
    },
    //汇总
    tHeaderSummary: ['日期', '编码', '产品名称', '单价', '数量', '金额'],
    filterValSummary: ['date', 'productCode', 'productName', 'price', 'amount', 'money'],
    //明细
    tHeaderDetail: ['日期', '完工人', '编码', '产品名称', '单价', '数量', '金额'],
    filterValDetail: ['date','staff', 'productCode', 'productName', 'price', 'amount', 'money'],
    // 进入全屏
    fullScreen(fullscreen){
      let element = document.documentElement;
      if (fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      fullscreen = !fullscreen;
      return fullscreen
    },
    getStaff () {
      return new Promise((resolve, reject) => {
        staffApi
          .getStaff()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getReportSummary (data) {
      return new Promise((resolve, reject) => {
        reportApi
          .getReportSummary(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getReportDetail (data) {
      return new Promise((resolve, reject) => {
        reportApi
          .getReportDetail(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    
}

export default common


// WEBPACK FOOTER //
// ./src/libs/common.js